const data = {
  id: 1,
  title: 'Unscramble words to make a completed sentence.',
  subTitle: 'Sắp xếp lại các từ theo đúng thứ tự để có một câu hoàn chỉnh',
  question: 'What are they doing?',
  answer: 'What are they doing?',
};

export default data;
